import { uniq } from 'lodash-es'

function checklistTasksHaveSameObserversRights (tasks) {
  const tasksReadRightsAsJsonString = tasks.map(task => {
    const groups = task.rights.observers.groups?.map(group => group.id).sort()
    const users = task.rights.observers.users?.map(user => user.id).sort()
    return JSON.stringify({ groups, users })
  })

  return uniq(tasksReadRightsAsJsonString).length === 1
}

function checklistTasksHaveSameResponsiblesRights (tasks) {
  const tasksResponsiblesRightsAsJsonString = tasks.map(task => {
    const groups = task.rights.responsibles.groups?.map(group => group.id).sort()
    const users = task.rights.responsibles.users?.map(user => user.id).sort()
    return JSON.stringify({ groups, users })
  })

  return uniq(tasksResponsiblesRightsAsJsonString).length === 1
}

function checklistTasksHaveSameValidatorsRights (tasks) {
  const tasksValidatorRightsAsJsonString = tasks.map(task => {
    const groups = task.rights.validators.groups?.map(group => group.id).sort()
    const users = task.rights.validators.users?.map(user => user.id).sort()
    return JSON.stringify({ groups, users })
  })

  return uniq(tasksValidatorRightsAsJsonString).length === 1
}

/**
 * Get the details of a status from information on a checklist task and the categories
 * @param {Number} statusId The id of the status we want to search details for
 * @param {String} statusCategory The category of the status we want to search details for
 * @param {Array} taskStatusCategories The status categories as received from the back-end
 * @returns {object} With more informations on the status
 */
export function getStatusDetailsByTaskInformation (statusId, statusCategory, taskStatusCategories) {
  const statusesInCategory = taskStatusCategories[statusCategory]
  return statusesInCategory
    ? statusesInCategory.find(label => label.id === statusId)
    : null
}

export function checklistTasksHaveSameRights (tasks) {
  return checklistTasksHaveSameObserversRights(tasks) &&
    checklistTasksHaveSameResponsiblesRights(tasks) &&
    checklistTasksHaveSameValidatorsRights(tasks)
}

export function splitChecklistStructureAndDetails (checklist) {
  const details = {
    sections: [],
    tasks: [],
  }
  const mapChecklistItemStructure = item => {
    details[item.type === 'title' ? 'sections' : 'tasks'].push({
      id: item.id,
      title: item.title,
      depth: item.depth,
      positionDisplay: item.positionDisplay,
      isAwaitingValidation: item.isAwaitingValidation,
    })

    return {
      id: item.id,
      type: item.type,
      children: item.children.map(mapChecklistItemStructure),
    }
  }

  const structure = checklist.map(mapChecklistItemStructure)

  return {
    structure,
    details,
  }
}

export function scrollToAddedItem (newAddedItem) {
  setTimeout(() => {
    const checklistTable = document.querySelector('.checklist-table')
    const elementTop = newAddedItem.offsetTop
    const elementHeight = newAddedItem.offsetHeight
    const containerHeight = checklistTable.clientHeight

    const scrollTarget = elementTop - (containerHeight / 2) + (elementHeight / 2)
    checklistTable.scrollTo({
      top: scrollTarget,
    })
  }, 0)
}